try {
  var scriptElement = document.createElement("script");
  var sourceUrl = "https://sdk.breeze.in/electron/163.0.0/index.js";
  scriptElement.setAttribute("src", sourceUrl);
  scriptElement.setAttribute("type", "module");
  scriptElement.setAttribute("id", "breeze-script-tag");
  scriptElement.setAttribute("data-environment", "release");
  scriptElement.setAttribute("data-platform", "shopify");
  scriptElement.setAttribute("data-enable-external-trackers", "true");
  scriptElement.setAttribute("data-enable-snap-tracker", "true");
  scriptElement.setAttribute("data-enable-ga", "true");
  scriptElement.setAttribute("data-enable-fbp", "true");
  scriptElement.setAttribute("data-emit-tracker-events", "true");
  scriptElement.setAttribute("data-ga4-measurement-id", "G-FLDG2E7NYB");
  scriptElement.setAttribute("data-merchantid", "farmkart");
  scriptElement.setAttribute("data-ga-version", "new");
  scriptElement.setAttribute("ghost-mode", "false");
  document.head.append(scriptElement);
} catch (e) {
  console.log("Something went wrong");
}
window.bzGhostMode = false;
// Add-to-cart selector covers both the standard primary button and the
// dynamic-checkout secondary variant rendered by snippets/buy-buttons.liquid.
// Required by the Breeze SDK to fire the GA4 add_to_cart event — was previously
// blank, which is why add_to_cart events were missing (13 events vs 51 purchases
// in the 90-day audit window ending 2026-04-25).
window.addToCartSelector =
  "button.product-form__submit, button[name='add']";
window.buyNowSelector =
  "button.btn.product-form__cart-submit.btn--secondary-accent";
window.checkoutSelector = "";

// Shop-by-crop image injector — bypasses Shopify section compilation cache
(function () {
  var CROPS = {
    cotton: 'fk-crop-cotton.jpg', tomato: 'fk-crop-tomato.jpg',
    wheat: 'fk-crop-wheat.jpg', paddy: 'fk-crop-paddy.jpg',
    soybean: 'fk-crop-soybean.jpg', onion: 'fk-crop-onion.jpg',
    sugarcane: 'fk-crop-sugarcane.jpg', chili: 'fk-crop-chili.jpg'
  };
  function getAssetBase() {
    var scripts = document.querySelectorAll('script[src*="/t/"][src*="/assets/"]');
    for (var i = 0; i < scripts.length; i++) {
      var m = scripts[i].src.match(/(.*\/assets\/)/);
      if (m) return m[1];
    }
    return null;
  }
  function injectImages() {
    var base = getAssetBase();
    if (!base) return;
    document.querySelectorAll('.sbc__tile').forEach(function (tile) {
      var label = tile.getAttribute('aria-label') || '';
      var m = label.match(/^([A-Za-z]+) farming guide/i);
      if (!m) return;
      var file = CROPS[m[1].toLowerCase()];
      if (!file) return;
      var src = base + file;
      var placeholder = tile.querySelector('.sbc__tile-placeholder');
      var img = tile.querySelector('.sbc__tile-img');
      if (placeholder) {
        var el = document.createElement('img');
        el.className = 'sbc__tile-img'; el.src = src;
        el.alt = m[1] + ' crop — FarmKart';
        el.width = 600; el.height = 900; el.loading = 'lazy';
        placeholder.replaceWith(el);
      } else if (img) {
        img.src = src; img.srcset = ''; img.sizes = '';
        img.width = 600; img.height = 900;
        img.alt = m[1] + ' crop — FarmKart';
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectImages);
  } else { injectImages(); }
})();
